(function(){
  function init(){
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    var wrap = document.getElementById('scWrap');
    if (!wrap) return;
    var pin = document.getElementById('scPin');
    var product = document.getElementById('scProduct');
    var shadow = document.getElementById('scShadow');
    var stage = document.getElementById('scStage');
    var title = wrap.querySelector('h1');

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isTouch = window.matchMedia('(hover: none)').matches;

    var tlIn = gsap.timeline({ defaults: { ease: 'power3.out' } });
    tlIn
      .fromTo(product, { opacity: 0, scale: .82, rotateY: -28, rotateX: 6 },
        { opacity: 1, scale: 1, rotateY: -10, rotateX: 2, duration: 1.3 })
      .to(shadow, { opacity: 1, duration: 1 }, '<')
      .to(title.querySelectorAll('.word'), { opacity: 1, y: 0, filter: 'blur(0px)', duration: .8, stagger: .1 }, '-=0.9')
      .to('#scSub', { opacity: 1, y: 0, duration: .7 }, '-=0.5')
      .to('#scCta', { opacity: 1, y: 0, duration: .7 }, '-=0.5')
      .to('#scHint', { opacity: 1, duration: .6 }, '-=0.3');

    // Balanceo continuo (turntable suave); nada si prefers-reduced-motion.
    // En tactil se nota mas fuerte: es la unica pista de que la imagen es
    // interactiva, al no haber inclinacion por raton ni scroll-jacking.
    if (!reduceMotion) {
      if (isTouch) {
        gsap.timeline({ repeat: -1, yoyo: true, delay: 1, defaults: { ease: 'sine.inOut' } })
          .to(product, { rotateY: 6, rotateX: -3, scale: 1.03, y: -12, duration: 2.6 })
          .to(product, { rotateY: -22, rotateX: 4, scale: 1, y: 6, duration: 3 });
      } else {
        gsap.timeline({ repeat: -1, yoyo: true, delay: 1.4, defaults: { ease: 'sine.inOut' } })
          .to(product, { rotateY: -3, rotateX: -1.5, y: -8, duration: 4 })
          .to(product, { rotateY: -14, rotateX: 3, y: 4, duration: 4.5 });
      }
    }

    // Inclinacion extra al mover el raton sobre el producto.
    if (!isTouch && !reduceMotion) {
      var setRotY = gsap.quickTo(product, 'rotateY', { duration: .6, ease: 'power3.out' });
      var setRotX = gsap.quickTo(product, 'rotateX', { duration: .6, ease: 'power3.out' });
      var baseRotY = -10;
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - .5;
        var py = (e.clientY - r.top) / r.height - .5;
        setRotY(baseRotY + px * 22);
        setRotX(-py * 12);
      });
    }

    // Escenas de scroll con pin nativo de GSAP (no CSS sticky: el sitio tiene
    // overflow-x:hidden en html/body que rompe position:sticky). Solo en
    // pantallas anchas: en movil el pin se queda "pillado" al hacer scroll.
    var enablePinScenes = window.matchMedia('(min-width: 901px)').matches;
    if (enablePinScenes) {
      ScrollTrigger.create({
        trigger: wrap, start: 'top top', end: 'bottom bottom', pin: pin, scrub: false, anticipatePin: 1
      });

      gsap.timeline({
        scrollTrigger: { trigger: wrap, start: 'top top', end: 'bottom bottom', scrub: .6 }
      })
        .to('#scHint', { opacity: 0, duration: .08 }, 0)
        .to(product, { rotateY: 22, rotateX: -4, scale: 1.08, y: -10, duration: .34 }, .08)
        .to(['#scCall1', '#scCall2', '#scCall3'], { opacity: 1, y: 0, duration: .16, stagger: .07 }, .34)
        .to(['#scCall1', '#scCall2', '#scCall3'], { opacity: 0, y: -10, duration: .12, stagger: .04 }, .74)
        .to(product, { rotateY: -8, rotateX: 0, scale: 1.05, duration: .2 }, .8)
        .to('.sc-copy', { opacity: 0, y: -20, duration: .2 }, .82);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
